<div class="m-portlet">
    <form [formGroup]="documentsForm" (ngSubmit)="onSubmitAddDocument()" novalidate>
        <div class="m-portlet__head pr-1">
            <div class="m-portlet__head-caption">
                <div class="m-portlet__head-title">
                    <h3 class="m-portlet__head-text">Dokumenti</h3>

                    <span class="m-portlet__head-text">
                        <a
                            [ngStyle]="styleMenu('icon')"
                            (click)="changeView()"
                            role="tab"
                            ngbTooltip="Pogled dokumentov"
                            container="body"
                            class="nav-link m-tabs__link pl-2"
                        >
                            <i
                                class="la"
                                [ngClass]="{
                                    'la- la-th-list': customerDocumentViewType === 'LARGE',
                                    'la- la-table': customerDocumentViewType === 'LIST',
                                    'la- la-th-large': customerDocumentViewType === 'SMALL'
                                }"
                            ></i>
                            <span class="m--font-brand"></span>
                        </a>
                    </span>
                </div>
            </div>
            <div class="m-portlet__head-tools">
                <ul role="tablist" style="border: none" class="nav nav-tabs m-tabs m-tabs-line m-tabs-line--right m-tabs-line-danger">
                    <li *ngIf="!isVisibleInput" [ngStyle]="styleMenu('icon')" class="nav-item m-tabs__item mr-3">
                        <a
                            (click)="filter(true)"
                            data-toggle="tab"
                            href="#m_portlet_tab_1_1"
                            role="tab"
                            aria-selected="true"
                            class="nav-link m-tabs__link active"
                        >
                            VSI
                            <span class="m--font-brand"></span>
                        </a>
                    </li>
                    <li *ngIf="!isVisibleInput" [ngStyle]="styleMenu('icon')" class="nav-item m-tabs__item mr-1">
                        <a
                            (click)="filter(false)"
                            data-toggle="tab"
                            href="#m_portlet_tab_1_2"
                            role="tab"
                            aria-selected="false"
                            class="nav-link m-tabs__link"
                        >
                            <i class="la la-photo"></i>
                            <span class="m--font-brand"></span>
                        </a>
                    </li>
                    <li *ngIf="!isVisibleInput" class="nav-item m-tabs__item mr-2">
                        <a (click)="addOrCancel()" aria-selected="false" class="nav-link m-tabs__link border-0">
                            <i class="la la-plus"></i>
                            <span class="m--font-brand"></span>
                        </a>
                    </li>
                    <li *ngIf="isVisibleInput" class="nav-item m-tabs__item mr-2">
                        <a (click)="addOrCancel(); filter(true)" aria-selected="false" class="nav-link m-tabs__link border-0">
                            <i class="la la-minus"></i>
                            <span class="m--font-brand"></span>
                        </a>
                    </li>
                    <li [ngStyle]="styleMenu('menuIcon')" class="nav-item m-tabs__item mr-2">
                        <a (click)="isMenuDropdownOpen = !isMenuDropdownOpen" aria-selected="false" class="nav-link m-tabs__link border-0">
                            <i class="la la-ellipsis-v"></i>
                            <span class="m--font-brand"></span>
                        </a>
                    </li>
                </ul>
            </div>
        </div>
        <div class="m-portlet__body">
            <div *ngIf="isMenuDropdownOpen" [ngStyle]="styleMenu('menuIcon')">
                <ul role="tablist" style="border: none" class="nav nav-tabs m-tabs m-tabs-line m-tabs-line-danger justify-content-between mb-0">
                    <a (click)="changeView()" role="tab" ngbTooltip="Pogled dokumentov" container="body" class="nav-link m-tabs__link pl-2 pt-0">
                        <i
                            class="la"
                            [ngClass]="{
                                'la- la-th-list': customerDocumentViewType === 'LARGE',
                                'la- la-table': customerDocumentViewType === 'LIST',
                                'la- la-th-large': customerDocumentViewType === 'SMALL'
                            }"
                        ></i>
                        <span class="m--font-brand"></span>
                    </a>
                    <li class="nav-item m-tabs__item mr-3">
                        <a
                            (click)="filter(true)"
                            data-toggle="tab"
                            href="#m_portlet_tab_1_1"
                            role="tab"
                            aria-selected="true"
                            class="nav-link m-tabs__link active pt-0"
                        >
                            VSI
                            <span class="m--font-brand"></span>
                        </a>
                    </li>
                    <li class="nav-item m-tabs__item mr-1">
                        <a
                            (click)="filter(false)"
                            data-toggle="tab"
                            href="#m_portlet_tab_1_2"
                            role="tab"
                            aria-selected="false"
                            class="nav-link m-tabs__link pt-0"
                        >
                            <i class="la la-photo"></i>
                            <span class="m--font-brand"></span>
                        </a>
                    </li>
                </ul>
                <hr />
            </div>
            <div *ngIf="isVisibleInput" class="upload">
                <div class="m-list-search pb-2">
                    <div class="m-list-search__results">
                        <div class="m-list-search__result-item">
                            <span class="m-list-search__result-item-icon">
                                <i
                                    ngbTooltip="Ime datoteke"
                                    class="la la-paperclip m--font-inverse-light"
                                    i18n-ngbTooltip="@@customer.documents.document.name"
                                ></i>
                            </span>
                            <span class="m-list-search__result-item-text">
                                <div class="custom-file">
                                    <input
                                        (change)="selectFile($event)"
                                        type="file"
                                        formControlName="uploadFile"
                                        value=""
                                        class="custom-file-input"
                                    />
                                    <label
                                        *ngIf="!selectedFilesForUpload"
                                        for="customFile"
                                        style="overflow: hidden"
                                        class="custom-file-label"
                                        i18n="@@1c5c1818ec70f305823c02110185baddd2c7df05"
                                    >
                                        Izberi datoteko
                                    </label>
                                    <label *ngIf="selectedFilesForUpload" for="customFile" style="overflow: hidden" class="custom-file-label">
                                        {{ selectedFilesForUpload[0].name }}
                                    </label>
                                </div>
                            </span>
                        </div>
                        <div class="m-list-search__result-item">
                            <span class="m-list-search__result-item-icon">
                                <i
                                    ngbTooltip="Naziv datoteke"
                                    class="la-i-cursor la m--font-inverse-light"
                                    i18n-ngbTooltip="@@customer.documents.document.title"
                                ></i>
                            </span>
                            <span class="m-list-search__result-item-text">
                                <input
                                    formControlName="comment"
                                    type="text"
                                    placeholder="Naziv (opcijsko)"
                                    class="form-control m-input"
                                    i18n-placeholder="@@cda17feb38df6acd536cd9f8bbfa73d24fa17c45"
                                />
                            </span>
                        </div>
                    </div>
                </div>
                <div>
                    <div *ngIf="percentDone" class="progress m-progress--sm">
                        <div
                            [style.width.%]="percentDone"
                            aria-valuemax="100"
                            aria-valuemin="0"
                            aria-valuenow="100"
                            role="progressbar"
                            class="progress-bar m--bg-primary"
                        ></div>
                    </div>

                    <button
                        type="submit"
                        class="m--align-right mt-2 mb-2 btn btn-outline-accent m-btn m-btn--custom m-btn--icon m-btn--pill btn-block"
                    >
                        <span>
                            <i class="la la-check"></i>
                            <span>Naloži</span>
                        </span>
                    </button>
                </div>
                <hr />
            </div>
            <div *ngIf="numberOfElements < 1" class="">Ni datotek.</div>
            <div
                class="m-widget4"
                [ngClass]="{
                    'd-flex justify-content-around flex-wrap': customerDocumentViewType === 'LARGE' || customerDocumentViewType === 'SMALL'
                }"
            >
                <common-document-list-element
                    *ngFor="let doc of allDocuments?.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage)"
                    [document]="doc"
                    [isReadOnly]="doc.isReadOnly"
                    [setThumbnail]="inputData"
                    [termData]="termData"
                    [showCreationLocation]="true"
                    (onOpenDocument)="openMediaViewDialog(doc)"
                    (onDelete)="removeDocumetFromlist(doc)"
                    (onDownloadDocument)="downloadDocument(doc)"
                    (attachToHD)="attachToHDChat(doc)"
                    (onShareDocument)="shareDocument($event)"
                    (onStopShareDocument)="stopShareDocument($event)"
                    class="document-element"
                ></common-document-list-element>
            </div>
            <ngb-pagination
                *ngIf="numberOfElements > itemsPerPage"
                [(page)]="currentPage"
                [collectionSize]="numberOfElements"
                [pageSize]="itemsPerPage"
                [directionLinks]="numberOfElements > itemsPerPage * 4"
                [maxSize]="4"
                class="d-flex justify-content-center align-self-end mt-2"
            ></ngb-pagination>
        </div>
    </form>
</div>
